var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
var ScrollReveal = function (_a) {
    var children = _a.children, _b = _a.delay, delay = _b === void 0 ? 0 : _b, _c = _a.direction, direction = _c === void 0 ? 'up' : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    var ref = useRef(null);
    var isInView = useInView(ref, { once: true, amount: 0.3 });
    var directions = {
        up: { y: 40 },
        down: { y: -40 },
        left: { x: 40 },
        right: { x: -40 }
    };
    return (React.createElement(motion.div, { ref: ref, initial: __assign({ opacity: 0 }, directions[direction]), animate: isInView ? {
            opacity: 1,
            y: 0,
            x: 0
        } : {}, transition: {
            duration: 0.6,
            delay: delay,
            ease: [0.25, 0.1, 0.25, 1]
        }, className: className }, children));
};
export default ScrollReveal;
